import { Menu as MenuIcon, Star } from "@mui/icons-material";
import { Box, IconButton, SxProps } from "@mui/material";
import { useStore } from "@priolo/jon";
import NatsCnnIcon from "components/NatsCnnIcon";
import SelectorCycleStatusH from "components/controls/select/SelectorCycleStatusH";
import SelectorPlannerShowH from "components/controls/select/SelectorPlannerShowH";
import TitleCmp from "components/header/TitleCmp";
import SearchFiltersUrl from "components/search/SearchFiltersUrl";
import CropRecipeDetailHeader from "pages/cropsRecipes/detail/Header";
import AlertFilterHeader from "pages/farms/alert/list/FilterHeader";
import AttachmentFilterHeader from "pages/farms/attach/FilterHeader";
import BiFilterHeader from "pages/farms/bi/FilterHeader";
import SearchField from "pages/farms/bi/SearchField";
import PlannerFilterHeader from "pages/farms/planner/PlannerFilterHeader";
import SelectorScopeAndGroupH from "pages/farms/planner/SelectorScopeAndGroupH";
import ProductionsFilterHeader from "pages/farms/productions/FilterHeader";
import IrriFilterHeader from "pages/plc/main/subsystems/irrigation/FilterHeader";
import LightFilterHeader from "pages/plc/main/subsystems/lighting/FilterHeader";
import MetaFilterHeader from "pages/plc/metadata/FilterHeader";
import FilterHeader from "pages/recipes/FilterHeader";
import NotifyButton from "pages/root/NotifyButton";
import { FunctionComponent, useMemo } from "react";
import drawerSo from "stores/mainMenu/drawer";
import { isChild } from "stores/mainMenu/utils";
import locationSo from "stores/route/location";
import { PAGE_ID, URL_PAR } from "stores/route/utils/types";
import userSo from "stores/user";
import palette from "styles/palette";
import theme from "styles/theme";
import UserButton from "../user/UserButton";
import SubtitleCmp from "./SubtitleCmp";



const isPLC = import.meta.env.VITE_TARGET == "plc"

const PageHeader: FunctionComponent = () => {

	// STORE
	useStore(locationSo)
	useStore(drawerSo)

	// HOOKs

	// HANDLERS
	const handleMenuClick = () => drawerSo.toggleOpen()

	// RENDER
	const currentPageId = locationSo.state.currentPage
	const isNatsVisible = useMemo(() => isPLC || isChild(currentPageId, PAGE_ID.FARMS), [currentPageId])
	const isUserDebug = userSo.isDebugger()

	return (
		<Box sx={cssRoot}>

			<IconButton
				onClick={handleMenuClick}
				disabled={drawerSo.state.isOpen}
			>
				<MenuIcon sx={[{ transition: "width 700ms ease" }, drawerSo.state.isOpen && { width: 0 }]} />
			</IconButton>

			{/* TITLE */}
			<Box sx={{ display: "flex", flexDirection: "column", ml: 0 }}>
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<TitleCmp />
					{isNatsVisible && <NatsCnnIcon />}
				</Box>
				<HeaderSubtitle pageId={currentPageId} />
			</Box>

			<Box sx={{ flex: "1 0 0" }} />

			{/* FILTRO TESTUALE */}
			<HeaderFilter pageId={currentPageId} />

			{/* ZERO-OS */}
			{!isPLC ? (
				isUserDebug && <NotifyButton sx={{ mx: 1 }} />

			// PLC-CONSOLE
			) : (
				userSo.isAdmin() && <Star fontSize={"16px" as any} />
			)}

			<UserButton sx={{ mx: 1 }} />

		</Box>
	)
}

export default PageHeader


const cssRoot = {
	display: "flex", justifyContent: "center", alignItems: "center",
	minHeight: theme.app.header.height,
	pr: 4,
	pl: 2,
	color: palette.text.primary,
	bgcolor: theme.palette.background.header,
	zIndex: theme.app.header.zIndex,
}


/** filtri della pagina. appaiono sotto al titolo */
const HeaderSubtitle: FunctionComponent<{ pageId: PAGE_ID }> = ({
	pageId
}) => {
	return {

		[PAGE_ID.FARM_PLANNER]: <PlannerFilterHeader endRender={<SelectorPlannerShowH />} />,
		[PAGE_ID.FARM_TASKS]: <PlannerFilterHeader endRender={<SelectorScopeAndGroupH />} />,
		[PAGE_ID.FARM_CYCLES]: <PlannerFilterHeader endRender={<SelectorCycleStatusH />} />,
		[PAGE_ID.FARM_ATTACH]: <AttachmentFilterHeader />,


		[PAGE_ID.FARM_AI_PLANNING]: <ProductionsFilterHeader />,
		[PAGE_ID.FARM_ALERTS]: <AlertFilterHeader />,
		[PAGE_ID.FARM_BI]: <BiFilterHeader />,


		[PAGE_ID.RECIPES]: <FilterHeader sx={{ ml: "-8px" }} />,
		[PAGE_ID.CROPS]: <FilterHeader sx={{ ml: "-8px" }} />,
		[PAGE_ID.CROPS_RECIPES]: <FilterHeader sx={{ ml: "-8px" }} />,
		[PAGE_ID.CROPS_RECIPES_DETAIL]: <CropRecipeDetailHeader />,
		[PAGE_ID.PRODUCTS]: <FilterHeader noFarms sx={{ ml: "-8px" }} />,


		[PAGE_ID.FARM_METADATA]: <MetaFilterHeader />,
		[PAGE_ID.GROWUNIT_LIGHTING]: <LightFilterHeader />,
		[PAGE_ID.GROWUNIT_IRRIGATION]: <IrriFilterHeader />,

	}[pageId as string] ?? <SubtitleCmp sx={{ opacity: 0.8, mr: 1 }} />
}

/** filtro testuale */
const HeaderFilter: FunctionComponent<{ pageId: PAGE_ID, sx?: SxProps }> = ({
	pageId,
	sx
}) => {
	return {
		[PAGE_ID.FARMS]: <SearchFiltersUrl />,
		[PAGE_ID.FARM_GROWUNITS]: <SearchFiltersUrl />,
		[PAGE_ID.FARM_CYCLES]: <SearchFiltersUrl sx={{ flex: 1 }} placeholder='Search by Ref and Crop' />,
		[PAGE_ID.FARM_BI]: <SearchField />,
		[PAGE_ID.FARM_TASKS]: <SearchFiltersUrl sx={{ flex: 1 }} />,
		[PAGE_ID.FARM_ALERTS]: <SearchFiltersUrl sx={{ flex: 1 }} />,
		[PAGE_ID.FARM_AI_PLANNING]: <SearchFiltersUrl sx={{ flex: 1 }} paramUrl={URL_PAR.PRODUCTION_SEARCH} />,
		[PAGE_ID.FARM_PLC_ALERTS]: <SearchFiltersUrl sx={{ flex: 1 }} placeholder='Search by Code and Description' />,
		[PAGE_ID.FARM_ATTACH]: <SearchFiltersUrl sx={{ flex: 1 }} placeholder='Search by Cycle ref and Task subject' />,


		[PAGE_ID.GROWUNIT_PLC_ALERTS]: <SearchFiltersUrl sx={{ flex: 1 }} placeholder='Search by Code and Description' />,
		[PAGE_ID.GROWUNIT_PLC_PROPERTIES]: <SearchFiltersUrl sx={{ flex: 1 }} placeholder='search by Alias, Description. Use "..." for full phrase' />,

		[PAGE_ID.COMPONENT_HVAC_ALERTS]: <SearchFiltersUrl sx={{ flex: 1 }} placeholder='Search by Code and Description' />,
		[PAGE_ID.COMPONENT_HVAC_PROPERTIES]: <SearchFiltersUrl sx={{ flex: 1 }} placeholder='search by Alias, Description. Use "..." for full phrase' />,

		[PAGE_ID.COMPONENT_OSMOTIC_WATER_ALERTS]: <SearchFiltersUrl sx={{ flex: 1 }} placeholder='Search by Code and Description' />,
		[PAGE_ID.COMPONENT_OSMOTIC_WATER_PROPERTIES]: <SearchFiltersUrl sx={{ flex: 1 }} placeholder='search by Alias, Description. Use "..." for full phrase' />,

		[PAGE_ID.COMPONENT_GERMINATION_ALERTS]: <SearchFiltersUrl sx={{ flex: 1 }} placeholder='Search by Code and Description' />,
		[PAGE_ID.COMPONENT_GERMINATION_PROPERTIES]: <SearchFiltersUrl sx={{ flex: 1 }} placeholder='search by Alias, Description. Use "..." for full phrase' />,

		[PAGE_ID.RECIPES]: <SearchFiltersUrl sx={{ flex: 1 }} />,
		[PAGE_ID.CROPS]: <SearchFiltersUrl sx={{ flex: 1 }} />,
		[PAGE_ID.CROPS_RECIPES]: <SearchFiltersUrl sx={{ flex: 1 }} />,
		[PAGE_ID.PRODUCTS]: <SearchFiltersUrl sx={{ flex: 1 }} />,
		[PAGE_ID.ALARMS]: <SearchFiltersUrl sx={{ flex: 1 }} />,
		[PAGE_ID.ROOT]: <SearchFiltersUrl showFilterButton sx={{ flex: 1 }} />,
		[PAGE_ID.FARM_METADATA]: <SearchFiltersUrl sx={{ flex: 1 }} placeholder='search by Name, Alias, Target, Description. Use "..." for full phrase' />,
	}[pageId as string]
}